import * as React from 'react';
import DashboardScreenshot from '../../assets/images/dashboard-screenshot.png';
import { i18n } from '../../i18n';

export default () => (
  <div className='content-body'>
    <img src={DashboardScreenshot} />
    <h5>{i18n.t('next_steps.dashboard.heading')}</h5>
    <p>{i18n.t('next_steps.dashboard.body')}</p>
  </div>
);
